import React, { Component, useEffect, useState, useRef } from 'react';
import {
  string, node, arrayOf, oneOfType, shape, bool
} from 'prop-types';
import DataProviderContext, { defaultContextValue } from './DataProviderContext';
import { addProduct, getProduct } from './product-cache';

export const DataProvider = ({
  batchedDomains, itemId, fetchPolicy, storeId, children
}) => {
  const disableSSR = !!(typeof window !== 'undefined' && window.DISABLE_SSR);
  const [mounted, setMounted] = useState(disableSSR);
  const productCache = useRef({});
  useEffect(() => {
    setMounted(true);
    if (typeof window !== 'undefined') {
      window.__PRODUCT_CACHE = productCache.current;
    }
  }, []);

  const value = {
    ...defaultContextValue,
    itemId,
    batchedDomains: {
      ...defaultContextValue.batchedDomains,
      ...batchedDomains
    },
    fetchPolicy,
    storeId,
    mounted,
    productCache: {
      addProduct: (arg) => addProduct(arg, productCache.current),
      getProduct: (arg) => getProduct(arg, productCache.current)
    }
  };

  return (
    <DataProviderContext.Provider value={value}>
      {children}
    </DataProviderContext.Provider>
  );
};

DataProvider.propTypes = {
  children: oneOfType([
    node,
    arrayOf(node),
  ]).isRequired,
  batchedDomains: shape({
    product: arrayOf(string),
    search: arrayOf(string)
  }).isRequired,
  itemId: string,
  fetchPolicy: string,
  storeId: string,
};

DataProvider.defaultProps = {
  fetchPolicy: null,
  itemId: null,
  storeId: null,
};
